import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    dateFormatter,
} from '../grid/ColumnHelpers'

import IzraktenisMap from '../karte/IzraktenisMap';
import * as maputils from '../karte/maputils'

import SplitterLayout from 'react-splitter-layout';

import {guiSet} from '../../actions/uiActions'
import {limitsSelected, openDok} from '../../actions/dokumentacijaActions'

import Grid from '../grid/Grid'
import BBoxFilterButtonToUrl from '../grid/BBoxFilterButtonToUrl'
import {getCommonColumns, getDoubleClickHandler, getEditColumnForDokSaraksts} from './common'
import ManiObjektiButton from '../grid/ManiObjektiButton'

const editIconColumn = getEditColumnForDokSaraksts({loc: 'loc_atradnes_limits', locDala: 'loc_atradnes_dala_limits'})

const columnNames = ['ir_derigs', 'atradne', 'adresats_nosaukums', 'kadastra_apzimejumi', 'ipasums_nosaukums',
     'izrakteni', 'izsniegts_datums','derigs_lidz_datums', 'anulets_datums', 'pase', 'licence', 'pielikumi_filename',
     'aktualizacijas_laiks', 'q_adm_ters']
const getColumns = ({kodif, user}) => {
  const allColumns = getCommonColumns({kodif, user, locijums: 'M'}).filter(c => columnNames.indexOf(c.dataField) !== -1)
  return [editIconColumn,...allColumns]
};

class LimitsSaraksts extends Component {

    mapPaneSizeChange = (h) => {
        this.props.guiSet('limits_saraksts_karte_height', h);
    }

    rowEvents = {
        onDoubleClick: getDoubleClickHandler({loc: 'loc_atradnes_limits', locDala: 'loc_atradnes_dala_limits', openDok: this.props.openDok})
    }

    render() {

        const {kodif, limiti, gui, limitsSelected, user} = this.props
        const {list, selected, loading, count} = limiti

        const vectorLayerCfgs = {
            limiti : {
                title: 'Limiti',
                features: list,
                styles: maputils.dokStyles.dokLimitiStyles,
                tooltipFunc: (feat) => `${feat.get('atradne') ? feat.get('atradne').tah_label : ''} ${dateFormatter(feat.get('izsniegts_datums'))} - ${feat.get('adresats_nosaukums')}`,
                selected: selected,
                legend: {
                    features: [
                        {
                          label: 'Limits',
                          geomType: 'polygon'
                        },
                        {
                          label: 'Limits (izvēlēts)',
                          geomType: 'polygon',
                          selected: true
                        }
                    ]
                  }
            }
        }

        if(!this.columns){
            this.columns = getColumns({
                kodif,
                user
            })
        }

        return (
            <SplitterLayout
                vertical
                percentage
                primaryIndex={1}
                secondaryInitialSize={gui.limits_saraksts_karte_height}
                onSecondaryPaneSizeChange={this.mapPaneSizeChange}>

                <IzraktenisMap mapId="limits_saraksts" vectorLayerCfgs={vectorLayerCfgs} />

                <Grid
                    onRowSelected={limitsSelected}
                    loading={loading}
                    selectedId={selected}
                    dataList={list}
                    totalCount={count}
                    columns={this.columns}
                    rowEvents={this.rowEvents}
                >

                <BBoxFilterButtonToUrl/>
                <ManiObjektiButton allText="Rādīt visas" maniText="Rādīt tikai manus limitus"/>
                </Grid>

            </SplitterLayout>
        )
    }
}

const mapStateToProps = ({kodif, limiti, gui, user}) => {
    return {kodif, limiti, gui, user}
}

export default connect(mapStateToProps, {limitsSelected, guiSet, openDok})(LimitsSaraksts)
